@if (isSuccess && data?.message?.toLowerCase() == 'success') {
  <div class="success-content">
    <div class="success-checkmark">
      <div class="check-icon">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
  </div>
} @else {
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable qwd-modal ">
    <div class="modal-background">
      <div class="modal-content message-content">
        <div class="qwd-status-circle qwd-approve-circle"
          [ngClass]="(isSavePrompt || isSuccess || isWarning || data?.isInfo) ? 'success' : 'error'"
          (click)="!isSuccess && !isWarning && !hasActions ? onClose() : ''">
          @if (isWarning) {
            <img src="assets/images/warning_alert-circle.svg" alt="" class="status-icon-img" />
          }
          @if (!isWarning) {
            <i class="status-icon"
            [ngClass]="(isSavePrompt || isSuccess || data?.isInfo) ? 'check' : 'cross'"></i>
          }
        </div>
        <p class="qwd-modal-des" [ngClass]="{ 'qwd-modal-des--warning': isWarning }">
          {{ message }}
        </p>
        @if (hasActions) {
          <div class="qwd-btns-container success-dialog-actions">
            <button type="button"
              class="qwd-modal-btn"
              [ngClass]="isSavePrompt ? 'cancel-btn' : 'error-btn'"
              (click)="onClose()"
              [disabled]="isSubmitting">
              {{ cancelLabel }}
            </button>
            <button type="button"
              class="qwd-modal-btn success-btn"
              (click)="onConfirm()"
              [disabled]="isSubmitting">
              {{ confirmLabel }}
            </button>
          </div>
        } @else {
          <button type="button"
            class="qwd-modal-btn"
            [ngClass]="isSuccess ? 'success-btn' : 'error-btn'"
            (click)="onClose()">
            {{ isSuccess ? labels?.continue : labels?.Close }}
          </button>
        }
      </div>
    </div>
  </div>
}
